import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {get_purchases} from "../../../redux/actions/user";
import ItemProductoPurchaseAccept from "../../../widgets/item_producto_purchase_accept";

const PurchasesAccept = ({
    purchases,
    get_purchases,
    current_page,
    last_page,
    links,
    peticion_purchases
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [voucherUrl, setVoucherUrl] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        get_purchases(1);
    }, [get_purchases]);

    useEffect(() => {
        if (!peticion_purchases) {  // Si no está haciendo la petición de compras
            get_purchases(1);  // Vuelve a cargar las compras
        }
    }, [peticion_purchases, get_purchases]);

    const translateState = (state) => {
        switch (state) {
            case 'awaiting':
                return 'Pendiente';
            case 'accepted':
                return 'Aceptada';
            case 'canceled':
                return 'Cancelada';
            default:
                return state;
        }
    };

    const formatDate = (date) => {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString('es-ES', options);
    };

    const getStateColor = (state) => {
        switch (state) {
            case 'en espera':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'aceptado':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'preparado':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'en camino':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'entregado':
                return 'bg-gray-100 text-gray-800 border-gray-200';
            case 'cancelado':
                return 'bg-red-100 text-red-800 border-red-200';
            case 'devolucion':
                return 'bg-orange-100 text-orange-800 border-orange-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const verifyShowVoucher = (purchase) => {
        if (purchase.qr_to_pay != null && purchase.payment_method_id == 1) {
            return true;
        }
        else {
            return false;
        }
    }

    const openModal = (voucherUrl) => {
        setVoucherUrl(voucherUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVoucherUrl(null);
    };

    return (
        <div className="max-w-6xl mx-xl-auto mt-12 mx-4 p-4 bg-white rounded-xl shadow-sm border border-gray-100">
            <h2 className="text-2xl font-bold mb-6 text-ecoprimary1 border-b pb-4">Productos Comprados</h2>

            {peticion_purchases ? (
                <div className="flex justify-center py-12">
                    <div className="animate-spin border-4 border-t-4 border-ecoprimary2 border-solid rounded-full w-12 h-12"></div>
                </div>
            ) : purchases.length === 0 ? (
                <div className='bg-blue-50 border border-blue-100 rounded-lg p-6 text-center'>
                    <p className="text-blue-800 font-medium mb-0">No tienes productos comprados registrados</p>
                </div>
            ) : (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-4">
                        {
                            purchases.map((product, index) => (
                                <ItemProductoPurchaseAccept
                                    product={product}
                                    key={index}
                                />
                            ))
                        }
                    </div>

                    {/* Paginación */}
                    <div className="flex justify-end mt-8 space-x-2">
                        {links && links.map((link, index) => {
                            const label = link.label.replace('&laquo;', '«').replace('&raquo;', '»');
                            return (
                                <button
                                    key={index}
                                    disabled={!link.url}
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(link.url?.split('?')[1]);
                                        const page = parseInt(urlParams.get('page'));
                                        if (page) get_purchases(page);
                                    }}
                                    className={`px-3.5 py-1.5 rounded-md border text-sm font-medium transition-colors
                                        ${link.active
                                            ? 'bg-ecoprimary1 text-white border-ecoprimary1 shadow-sm'
                                            : 'bg-white text-gray-600 hover:bg-gray-50 border-gray-200'}
                                        ${!link.url && 'opacity-50 cursor-not-allowed'}`}
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                </>
            )}

            {/* Modal para mostrar el voucher */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex justify-center items-center z-[100] transition-opacity p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden animate-fade-in-up">
                        <div className="p-4 border-b flex justify-between items-center bg-gray-50">
                            <h3 className="text-lg font-bold text-ecoprimary1 m-0">Comprobante de Pago</h3>
                            <button
                                onClick={() => closeModal()}
                                className="text-gray-400 hover:text-gray-700 transition-colors w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200"
                                aria-label="Cerrar"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="p-6 flex justify-center bg-gray-100/50">
                            <img
                                src={voucherUrl}
                                alt="Voucher de pago"
                                className="max-w-full h-auto max-h-[70vh] rounded-lg shadow-sm border border-gray-200 object-contain"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    purchases: state.User.purchases,
    current_page: state.User.current_page,
    last_page: state.User.last_page,
    links: state.User.links,
    peticion_purchases: state.User.peticion_purchases
});

export default connect(mapStateToProps, { get_purchases })(PurchasesAccept);
